import { Phone, MapPin, Menu, X } from "lucide-react";
import { useState, useMemo } from "react";

const useIsOpen = () => {
  return useMemo(() => {
    const now = new Date();
    const day = now.getDay(); // 0=Sun, 6=Sat
    const hour = now.getHours();
    const min = now.getMinutes();
    const time = hour + min / 60;

    if (day >= 1 && day <= 5) return time >= 9 && time < 17; // Mon-Fri 9AM-5PM
    if (day === 0 || day === 6) return time >= 12 && time < 15; // Sat-Sun 12-3PM
    return false;
  }, []);
};
import { Button } from "@/components/ui/button";
import DarkModeToggle from "@/components/DarkModeToggle";

const SiteHeader = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const isOpen = useIsOpen();

  return (
    <>
      {/* Top utility bar */}
      <div className="bg-primary text-primary-foreground">
        <div className="container flex items-center justify-between py-2 text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:+16782360376" className="flex items-center gap-1.5 hover:opacity-80 transition-opacity">
              <Phone className="h-3.5 w-3.5" />
              <span className="font-medium">(678) 236-0376</span>
            </a>
            <span className="hidden sm:flex items-center gap-1.5 text-primary-foreground">
              <MapPin className="h-3.5 w-3.5" />
              3079 Roswell Rd, Marietta, GA
            </span>
          </div>
          {isOpen && (
            <div className="flex items-center gap-2">
              <span className="flex items-center gap-1.5">
                <span className="h-2 w-2 rounded-full bg-success animate-pulse" />
                <span className="text-xs font-medium">Open Now</span>
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Main nav */}
      <header className="sticky top-0 z-50 bg-card/95 backdrop-blur-md border-b">
        <div className="container flex items-center justify-between py-4">
          <a href="/" className="font-display text-xl font-extrabold tracking-tight text-foreground">
            Computer Zone
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {["Services", "Blog", "About", "How It Works", "Contact"].map((item) => (
              <a
                key={item}
                href={item === "Blog" ? "/blog" : `/#${item.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                {item}
              </a>
            ))}
            <a href="/membership" className="text-sm font-semibold text-primary hover:opacity-80 transition-opacity">
              Membership
            </a>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <DarkModeToggle />
            <Button asChild variant="default" size="sm" className="font-semibold">
              <a href="/#booking">Schedule Appointment</a>
            </Button>
          </div>

          <button
            className="md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            aria-controls="mobile-menu"
          >
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {mobileOpen && (
          <div id="mobile-menu" className="md:hidden border-t bg-card px-6 py-4 space-y-3">
            {["Services", "Blog", "About", "How It Works", "Contact"].map((item) => (
              <a
                key={item}
                href={item === "Blog" ? "/blog" : `/#${item.toLowerCase().replace(/\s+/g, "-")}`}
                className="block text-sm font-medium text-muted-foreground py-2"
                onClick={() => setMobileOpen(false)}
              >
                {item}
              </a>
            ))}
            <a
              href="/membership"
              className="block text-sm font-semibold text-primary py-2"
              onClick={() => setMobileOpen(false)}
            >
              Membership
            </a>
            <Button asChild className="w-full font-semibold">
              <a href="/#booking" onClick={() => setMobileOpen(false)}>Schedule Appointment</a>
            </Button>
          </div>
        )}
      </header>
    </>
  );
};

export default SiteHeader;
